export default __webpack_public_path__ + "static/media/John-Lovick.16b07b8b.jpg";